import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const userService = {
    storeUser,
    getUser,
    editUser,
    deleteUser,
    getCurrentUser,
    updatePermission,
    getUsersPagination,
    getOrderUsers,
    updateOrderModerator,
    updateUserStatus,
    showPassword,
}

function storeUser(userData) {
    return SC.postCall('users', userData);
}

function getUser(userId) {
    return SC.getCall(`users/${pathSegment(userId)}`);
}

function editUser(userData, userId) {
    return SC.putCall(`users/${pathSegment(userId)}`, userData);
}


function deleteUser(userId) {
    return SC.deleteCall(`users/${pathSegment(userId)}`);
}

function getUsersPagination(page, filter, sort, pageSize, status) {
    return SC.getCall('users', { page, filter, sort, pageSize, status });
}

function getCurrentUser() {
    return SC.getCall('getUsersData');
}

function updatePermission(userId) {
    return SC.getCall(`changePrimaryContact/${pathSegment(userId)}`);
}

function getOrderUsers() {
    return SC.getCall('getAllUsersDoNotHaveAgency');
}

function updateOrderModerator(data, orderId) {
    return SC.putCall(`updateOrderDetailsUsers/${pathSegment(orderId)}/update`, data);
}

function updateUserStatus(userId, data) {
    return SC.putCall(`users/updateStatus/${pathSegment(userId)}`, data);
}

function showPassword(userId) {
    return SC.getCall(`showPassword/${pathSegment(userId)}`);
}
